export default __webpack_public_path__ + "static/media/img_5.fa81270c.jpg";